import { jsx } from "react/jsx-runtime";
import { Modal } from "@zillow/constellation-10";
import { event } from "@zillow/universal-analytics";
import { usePageProps, getCmsInfoForPage } from "@zillow/zrs-cms";
import React, { useRef, useCallback } from "react";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const BlockModalDialog = ({
  attrs,
  innerBlocks = [],
  index
}) => {
  const {
    id,
    size = "md",
    open: _open,
    ...rest
  } = attrs;
  const pageProps = usePageProps();
  const lastOpen = useRef(false);
  const handleOpenChange = useCallback((open) => {
    if (open === lastOpen.current) return;
    lastOpen.current = open;
    if (open) {
      event({
        // https://dataportal.zillowgroup.net/event-registry/2048
        envelope: {
          event_type_id: "5030",
          event_type_version_id: "1",
          event_template_id: "297",
          event_template_version_id: "1"
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: "interaction",
          trigger_location_nm: "cms",
          trigger_source_nm: "cms_modal",
          trigger_object_nm: "no_trigger_object"
        },
        semantic: {
          semantic_event_nm: "cms_open"
        },
        cms_info: {
          block_id: id || "",
          block_type_cd: "modal_dialog",
          ...getCmsInfoForPage(pageProps)
        }
      });
    } else {
      event({
        // https://dataportal.zillowgroup.net/event-registry/2051
        envelope: {
          event_type_id: "2051",
          event_type_version_id: "1",
          event_template_id: "126",
          event_template_version_id: "1"
          // Master ID: 2284.2.126.1
        },
        clickstream_trigger: {
          trigger_type_nm: "interaction",
          trigger_location_nm: "cms",
          trigger_source_nm: "cms_modal",
          trigger_object_nm: "no_trigger_object"
        },
        semantic: {
          semantic_event_nm: "cms_close"
        },
        cms_info: {
          block_id: id || "",
          block_type_cd: "modal_dialog",
          ...getCmsInfoForPage(pageProps)
        }
      });
    }
  }, [id, pageProps]);
  const body = /* @__PURE__ */ jsx(React.Fragment, { children: generateBlockList({
    blocks: innerBlocks
  }) });
  return /* @__PURE__ */ jsx(Modal, { ...rest, size, body, trigger: null, multiModalTriggerId: id, onOpenChange: handleOpenChange }, index);
};
export {
  BlockModalDialog as default
};
